import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppConfig } from "../config/config";
import { ResponsePackage } from "shared-lib";
import { PoleMapDto, PolePopupDto } from "../models/pole-map.model";
import { Observable } from "rxjs";

@Injectable({
    providedIn: 'root',
})
export class PoleService {
    private pathApi: string;
    constructor(private http: HttpClient, private config: AppConfig) {
        this.pathApi = this.config.setting['pathApi'] + 'pole/';
    }

    private headers = new HttpHeaders({ 'Content-Type': 'application/json' });

    getPopupInfo(id: number) {
        return this.http.get<ResponsePackage<PolePopupDto>>(`${this.pathApi}getPopupInfo/${id}`, { headers: this.headers, observe: 'response' });
    }

    getMapDetails(id: number) {
        return this.http.get<ResponsePackage<PoleMapDto>>(`${this.pathApi}getMapDetails/${id}`, { headers: this.headers, observe: 'response' });
    }

    getPolesForMapFilter(dataIn: any): Observable<any> {
        return this.http.post(`${this.pathApi}getPolesForMapFilter`, dataIn, { observe: 'response' });
    }
}